import { render, staticRenderFns } from "./ren-task-entrust.vue?vue&type=template&id=145950c5&"
import script from "./ren-task-entrust.vue?vue&type=script&lang=js&"
export * from "./ren-task-entrust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports